import { Component } from '@angular/core';

@Component({
    selector: 'app-app-header',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.scss'],
    standalone: false
})
export class AppHeaderComponent {

}
